import Button, { BUTTON_HEIGHT_24 } from '../../Button'

import { QA_NAME_DELETE_RECIPIENT_BUTTON } from './EmailActionDeleteButton.constants'

import * as styles from './EmailActionDeleteButton.module.css'

import DeleteIcon from '../../../icons/delete.svg'

function EmailActionDeleteButton(props) {
  return (
    <Button.Icon
      {...props}
      isGrey
      Icon={DeleteIcon}
      className={styles.deleteButton}
      height={BUTTON_HEIGHT_24}
      qaName={QA_NAME_DELETE_RECIPIENT_BUTTON}
    />
  )
}

export default EmailActionDeleteButton
